import * as React from 'react';
import { useEffect } from 'react';
import RssItemsCmp from './RssItemsCmp';
import { Container } from 'reactstrap';
import { useLatestItems } from '../../hooks/useQueries';
import { useAppContext } from '../../providers/AppContext';

export default function RssLatestPage() {
  const { setPageTitle } = useAppContext();
  const { data: result } = useLatestItems();

  useEffect(() => {
    setPageTitle('Son Dakika Haberleri');
    document.title = 'Gazete Bayii - Son Dakika Haberleri';
  }, [setPageTitle]);

  const latestItems = result?.result;

  return (
    <Container>
      {latestItems ? (
        <React.Fragment>
          <RssItemsCmp items={latestItems} />
        </React.Fragment>
      ) : (
        <React.Fragment />
      )}
    </Container>
  );
}
